var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { FsEntryType } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
import { FILE_BROWSER_CURRENT_DIR_QUERY_PARAM, usePlugFilespaceClient, } from '@lucidlink/workspacemanagement';
import { FOCUSED_ENTRY_ID_QUERY_PARAM } from '#constants';
export const useGuestLinkGoToFolder = () => {
    _react_refresh_temp_1();
    const navigate = useNavigate();
    const { addToast } = useToastService();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const mutation = useMutation({
        mutationFn: async ({ filespaceId, fsEntryId, workspaceId, }) => {
            const entryInfo = await plugFilespaceClient({
                action: (fsClient) => fsClient.fileSystem().getEntryInfoById(fsEntryId),
                filespaceId,
                workspaceId,
            });
            const isDir = entryInfo.key.type === FsEntryType.DIR;
            const search = createSearchParams(isDir
                ? {
                    [FILE_BROWSER_CURRENT_DIR_QUERY_PARAM]: entryInfo.key.id,
                }
                : {
                    [FILE_BROWSER_CURRENT_DIR_QUERY_PARAM]: entryInfo.parentId,
                    [FOCUSED_ENTRY_ID_QUERY_PARAM]: entryInfo.key.id,
                });
            await navigate({
                pathname: `/workspaces/${workspaceId}/filespaces/${filespaceId}/browser`,
                search: `?${search}`,
            }, {
                flushSync: true,
            });
        },
        onError: () => {
            addToast({
                'data-testid': 'error-guest-link-go-to-folder',
                kind: 'negative',
                hasCloseButton: true,
                content: {
                    message: translate('The file/folder has not been found, or you do not have access to it.'),
                },
            });
        },
        networkMode: 'always',
    });
    return {
        goToFolder: (args) => {
            mutation.mutate(args);
        },
    };
};
_react_refresh_temp_1(useGuestLinkGoToFolder, "BYW5WeDru9YYeJoonkId2iuMzSY=", false, () => [useNavigate, useToastService, usePlugFilespaceClient, useMutation]);
